import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { clearUserSession } from '../../../utils/AccountsStorageUtils';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

interface UseGetUserLogoutAPIInterface {
  userLogoutAPI: UseMutateAsyncFunction<
    void,
    unknown,
    {
      afterLogout?: () => void;
    } | void,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useGetUserLogoutAPI = (): UseGetUserLogoutAPIInterface => {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getUserLogout = (options: { afterLogout?: () => void }) => {
    return ibUserAccountsAPIService
      .userLogout()
      .then(() => {
        if (options?.afterLogout) {
          options.afterLogout();
        } else clearUserSession();
      })
      .catch(() => {
        if (options?.afterLogout) {
          options.afterLogout();
        } else clearUserSession();
      });
  };

  const { mutateAsync, error, status } = useMutation(getUserLogout, {
    mutationKey: ['userLogoutAPI']
  });

  return {
    userLogoutAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetUserLogoutAPI };
